import { useState } from 'react'
import type { QueryState } from '@/api/useApiQuery'
import { useForcedSkeletons } from '@/api/skeletonDebug'

/**
 * The last successful payload of a query, kept across refetches. Every write
 * refetches, and without this each save would swap the page for a skeleton
 * and back.
 */
export function useLastData<T>(query: QueryState<T>): T | null {
  const [last, setLast] = useState<T | null>(null)
  if (query.status === 'success' && query.data !== last) setLast(query.data)
  if (useForcedSkeletons()) return null
  return query.status === 'success' ? query.data : last
}
